import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Close from '../Close';
import Loader from '../Loader';

export default class QuickView extends PureComponent {
  contentClassName = 'quick-view-content';

  handleClick = event => {
    if (!event.target.closest(`.${this.contentClassName}`)) {
      this.props.onClose();
    }
  };

  render () {
    return (
      <aside className={`quick-view ${this.props.isActive ? 'active' : ''}`} onClick={this.handleClick}>
        <div className={this.contentClassName}>
          {this.props.isLoading ? <Loader /> : (
            <Fragment>
              {this.props.children}
              { this.props.closeButtonComponent || <Close onClick={this.props.onClose} />}
            </Fragment>
          )}
        </div>
      </aside>
    );
  }
}

QuickView.propTypes = {
  isActive: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  closeButtonComponent: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/common/ui/QuickView/QuickView.js